import styled from 'react-emotion'

const Icon = styled.div``

export default Icon



// WEBPACK FOOTER //
// ./src/components/PageHeader/Icon.js